// extracted by mini-css-extract-plugin
export default {"thinDivider":"thinDivider--35UZk","thickDivider":"thickDivider--CR6ys"};